// Copyright (c) 2024. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { ButtonStyle } from "../../../../io/hyperify/core/frontend/button/ButtonStyle";
import { has } from "../../../../io/hyperify/core/functions/has";
import { map } from "../../../../io/hyperify/core/functions/map";
import {
    createProductModel,
    ProductModel,
} from "../../../../io/hyperify/core/store/types/product/ProductModel";
import { TranslationFunction } from "../../../../io/hyperify/core/types/TranslationFunction";
import { SHELL_FEATURE_IMAGE } from "../../core/constants/shell";
import {
    T_READ_MORE,
    T_SHELL_FEATURE_SUMMARY,
    T_SHELL_FEATURE_TITLE,
} from "../../core/constants/translation";
import { SendanorIcon } from "../../core/types/SendanorIcon";
import {
    getIconComponent,
} from "../assets/icons";

const SHELL_FEATURE_ID = (id: string) : string => {
    return `feature#${id}`;
};

const SHELL_FEATURE_ICON = (_id: string) : any => {
    const iconType : SendanorIcon = has(SHELL_FEATURE_IMAGE, _id) ? SHELL_FEATURE_IMAGE[_id] : SendanorIcon.WebHotelsIcon;
    const Icon : any = getIconComponent(iconType);
    return <Icon />;
};

const SHELL_FEATURE_URL = (id: string) : string => {
    return `https://shell.sendanor.fi/${id}.html`;
};

/**
 *
 * @param id
 * @param icon
 * @param url
 * @param title
 * @param summary
 * @param buttonLabel
 */
function createShellFeature (
    id: string,
    icon: any,
    url: string,
    title: string,
    summary: string,
    buttonLabel: string,
): ProductModel {
    return createProductModel(
        id,
        icon,
        title,
        summary,
        url,
        buttonLabel,
        undefined,
        undefined,
        ButtonStyle.SECONDARY,
    );
}

/**
 *
 */
export function useShellFeatureList (
    list : readonly string[],
    t : TranslationFunction,
): ProductModel[] {
    const buttonLabel = t(T_READ_MORE);
    return map(list, (id) => {
        return createShellFeature(
            SHELL_FEATURE_ID(id),
            SHELL_FEATURE_ICON(id),
            SHELL_FEATURE_URL(id),
            t(T_SHELL_FEATURE_TITLE(id)),
            t(T_SHELL_FEATURE_SUMMARY(id)),
            buttonLabel,
        );
    });
}
